import React from 'react';
import localization from '../helpers/localization.js';
import {contentRoot} from '../config.js';
const OfferRequestSentPage = ({ onNewPlanClick, gotoStart, sendingPlan, notConnected }) => {
    if (sendingPlan) {
        return (<div className="offerSentPage">
            <img className="img-fluid" src={contentRoot + "/img/Loading_icon.gif"}></img>
            <h1>{localization.sendingOfferRequest}</h1>
        </div>);
    }
    else if (notConnected)
    {
        return (<div className="offerSentPage">
            <img src={contentRoot + "img/error.svg"}></img>
            <h1>{localization.failedRequestMessage}</h1>
        </div>);
    }
    else {
        return (<div className="offerSentPage">
            <picture>
                <source srcSet={contentRoot + "img/check.webp"} type="image/webp" />
                <img src={contentRoot + "img/check.png"} alt="ok" />
            </picture>
            <h1>{localization.offerRequestSent}</h1>
            <p>{localization.thankYouMainlabel}</p>
            {(gotoStart) ? < div className="orangeButton" onClick={() => { onNewPlanClick(); gotoStart(); }}><span className="buttonTxt">{localization.makeNewPlan}</span></div> : ""}
        </div>);
    }
}
export default OfferRequestSentPage


